import { PageAudienceFilter, usePageFilterContext } from '@/components/page';
import PendoPlaceholder from '@/components/PendoPlaceholder/PendoPlaceholder';
import ShareMenu from '@/features/ShareMenu';

const PaidSearchOverviewActions = () => {
  const {
    pageFilters: { audience },
  } = usePageFilterContext();

  return (
    <div className="flex items-center gap-2">
      <PendoPlaceholder />
      <PageAudienceFilter />
      <ShareMenu
        notificationPageKey="paidsearch-adgroups"
        notificationParams={{
          audienceIds: audience?.id,
        }}
      />
    </div>
  );
};

export default PaidSearchOverviewActions;
